import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Resets scroll position on route changes so navigating never lands mid-page. Leaves
 * hash navigation (e.g. `/#programs`) alone so in-page anchor scrolling still works. */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}
